import React, { useState, useContext } from 'react';
import { LinearProgress } from '@mui/material';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import { NotebookFeedbackCtx, notebookDefaultProperties, UserCtx, } from '../../App/ApplicationContext';
import { NewNotebook, ResumeNotebook } from './NotebookDialog';
import { NotebookGeneratingAlert, NotebookReadyAlert, NotebookDownloadingAlert, NotebookWorkerAlert, NotebookErrorAlert, } from '../../GenericUI/Alerts';
import { DialogWrapper } from '../../GenericUI/DialogWrapper';
import { getNotebookInfo } from '../../../utils/Swirrl/sizeCalculation';
import { Status, } from '../../../types/searchTypes';
export const NotebookUI = ({ handleClose, fileListObject, completed, myQueryLimit, operation, subsettingParameters, subsettingMode, }) => {
    let stageSize = 0;
    if (fileListObject) {
        fileListObject.forEach((e) => {
            e.fileList.forEach((file) => {
                stageSize += file.size;
            });
        });
    }
    const [notebookSize, setNotebookSize] = useState({});
    const { notebookProperties, setNotebookProperties } = useContext(NotebookFeedbackCtx);
    const { user } = useContext(UserCtx);
    const { notebookURL, sessionId } = user;
    switch (notebookProperties.processingStatus) {
        case Status.IDLE:
            if (!notebookSize) {
                setNotebookSize({
                    currentSize: -1,
                    currentStatus: '',
                });
                if (user && user.notebookId && user.notebookURL) {
                    getNotebookInfo(user.notebookId, user.notebookURL)
                        .then((info) => {
                        setNotebookSize(info);
                    })
                        .catch((err) => console.error(err));
                }
            }
            if (notebookURL && sessionId) {
                return (React.createElement(ResumeNotebook, Object.assign({}, {
                    completed,
                    fileListObject,
                    myQueryLimit,
                    operation,
                    subsettingParameters,
                    notebookURL,
                    notebookSize,
                    stageSize,
                    subsettingMode,
                    serviceUrl: '',
                })));
            }
            return (React.createElement(NewNotebook, Object.assign({}, {
                completed,
                fileListObject,
                myQueryLimit,
                notebookSize,
                operation,
                subsettingParameters,
                subsettingMode,
                stageSize,
                serviceUrl: '',
            })));
        case Status.GENERATING:
            return (React.createElement(DialogWrapper, { title: 'Generating', buttonTitle: null, buttonCallback: () => { }, buttonDisabled: null, size: false, clearOnClose: false },
                React.createElement(React.Fragment, null,
                    React.createElement(LinearProgress, null),
                    React.createElement("br", null),
                    React.createElement(NotebookGeneratingAlert, null))));
        case Status.ERROR:
            return (React.createElement(DialogWrapper, { title: 'Error', buttonTitle: null, buttonCallback: () => { }, buttonDisabled: null, size: false, clearOnClose: false },
                React.createElement(NotebookErrorAlert, { error: notebookProperties.error || 'No error details' })));
        case Status.READY:
            return (React.createElement(DialogWrapper, { title: 'Ready', buttonTitle: 'Open Notebook', clearOnClose: true, buttonCallback: () => {
                    const redirectUrlToken = notebookProperties.redirectUrl.split('?');
                    window.open(`${redirectUrlToken[0]}/lab/tree/Welcome%20to%20SWIRRL.md?${redirectUrlToken[1]}`, '_blank');
                    setNotebookProperties(notebookDefaultProperties);
                    handleClose();
                }, buttonDisabled: false, size: false },
                React.createElement(List, null,
                    React.createElement(Divider, { component: 'li' }),
                    React.createElement(NotebookReadyAlert, null),
                    React.createElement(Divider, { component: 'li' }),
                    React.createElement(NotebookWorkerAlert, { workerNumber: notebookProperties.workerNumber || 0 }),
                    React.createElement(Divider, { component: 'li' }),
                    React.createElement(NotebookDownloadingAlert, null),
                    React.createElement(Divider, { component: 'li' }))));
        default:
            return React.createElement("div", null);
    }
};
